import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-workorders-home',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './workorders-home.component.html',
  styleUrls: ['./workorders-home.component.scss'],
})
export class WorkordersHomeComponent {}
